import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'

export const DefenseStatusLabel = {
  1: '正常',
  2: '不正常'
}

export enum AccountStatus {
  /** 已启用 */
  enable = 1,
  /** 已禁用 */
  disable = 2,
  /** 启用中 */
  disabling = 11,
  /** 禁用中 */
  enabling = 22,
}

export const AccountStatusLabel = {
  /** 已启用 */
  1: '已启用',
  /** 已禁用 */
  2: '已禁用',
  /** 启用中 */
  11: '启用中',
  /** 禁用中 */
  22: '禁用中',
}

export interface DisableAccountReq {
  /** 状态 1：启用 2：禁用 */
  status: number
  /** 终端id */
  device_id?: string
  /** 用户名 */
  name?: string
}

@Injectable()
export class BaseInfoService {
  constructor (private http: Http) {
  }

  disableAccount (data: DisableAccountReq) {
    return this.http.post('/terminal-order/disable', data)
  }
}
